/**
 * registrationData.ts - Reads the current form/DOM state into the
 * request payloads the server expects. Shared by the Stripe init call
 * (registerInit sends everything except payment info) and the final
 * submit (adds PaymentIntentId once payment is confirmed).
 */
import { state } from './config';
import { getInputValue, getCheckboxValue } from './utils';
import type { PlayerDto, RegisterInitRequest, RegistrationPayload } from './types';

export function collectPlayers(): PlayerDto[] {
    const playerCards = document.querySelectorAll<HTMLElement>('.player-card');
    const players: PlayerDto[] = [];

    playerCards.forEach((card, idx) => {
        const sectionRadio = document.querySelector<HTMLInputElement>(`input[name="Players[${idx}].SelectedSectionId"]:checked`);
        const payoutMethodSelect = document.querySelector<HTMLSelectElement>(`[name="Players[${idx}].PayoutMethod"]`);
        const payoutAccountInput = document.querySelector<HTMLInputElement>(`[name="Players[${idx}].PayoutAccount"]`);

        const requestedByes = Array.from(
            document.querySelectorAll<HTMLInputElement>(`input[name="Players[${idx}].RequestedByes"]:checked`)
        ).map(cb => parseInt(cb.value, 10));

        const dobInput = card.querySelector<HTMLInputElement>('.js-dob-input');
        const gradeSelect = card.querySelector<HTMLSelectElement>('.js-grade-input');
        const ratingInput = card.querySelector<HTMLInputElement>('.js-rating-input');

        players.push({
            UscfId: card.querySelector<HTMLInputElement>('.js-uscf-input')?.value.trim() || '',
            Rating: ratingInput && ratingInput.value ? parseInt(ratingInput.value, 10) : null,
            FirstName: card.querySelector<HTMLInputElement>('.js-first-name')?.value.trim() || '',
            LastName: card.querySelector<HTMLInputElement>('.js-last-name')?.value.trim() || '',
            DateOfBirth: dobInput && dobInput.value ? dobInput.value : null,
            Grade: gradeSelect && gradeSelect.value ? gradeSelect.value : null,
            SelectedSectionId: sectionRadio ? sectionRadio.value : 'Open',
            RequestedByes: requestedByes,
            PayoutMethod: payoutMethodSelect ? payoutMethodSelect.value : 'Zelle',
            PayoutAccount: payoutAccountInput ? payoutAccountInput.value.trim() : ''
        });
    });

    return players;
}

export function buildRegisterInitRequest(): RegisterInitRequest {
    return {
        Players: collectPlayers(),
        Contact: {
            ParentEmail: getInputValue('Contact_ParentEmail'),
            ParentPhone: getInputValue('Contact_ParentPhone'),
            OptInNewsletter: getCheckboxValue('Contact_OptInNewsletter'),
            NotifyViaSmsPairings: getCheckboxValue('Contact_NotifyViaSmsPairings'),
            NotifyViaSmsResults: getCheckboxValue('Contact_NotifyViaSmsResults'),
            PhotoOptOut: getCheckboxValue('Contact_PhotoOptOut')
        },
        AddOns: {
            SupportDonation: state.donationAmount
        }
    };
}

export function buildFinalRegistrationPayload(paymentIntentId: string | null): RegistrationPayload {
    const draft = buildRegisterInitRequest();
    return {
        ...draft,
        Payment: {
            Method: state.paymentMethod,
            PaymentIntentId: paymentIntentId
        }
    };
}